import React from "react";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import {
  FilledInput,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from "@material-ui/core";

const PasswordInputField = ({
  fieldName,
  label,
  error,
  placeholder,
  handleChange,
  values,
  autoFocus = false,
}) => {
  const [onClickShowPassword, setOnClickShowPassword] = React.useState(false);

  return (
    <Grid container direction="column" className="password-input-field">
      <Typography variant="body1" className="label">
        {label}
      </Typography>
      <FilledInput
        autoFocus={autoFocus}
        placeholder={placeholder}
        disableUnderline
        type={`${onClickShowPassword ? "text" : "password"}`}
        fullWidth
        onChange={handleChange}
        name={fieldName}
        value={values}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              onClick={() => setOnClickShowPassword((prevState) => !prevState)}
            >
              {onClickShowPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
      <Typography variant="caption" className="error">
        {error}
      </Typography>
    </Grid>
  );
};
export default PasswordInputField;
